import styled from "styled-components";

export const Wrap = styled.div`
  background-color: #f9f9ff;
`;
export const Wrapper = styled.div`
  font-family: Poppins;
  border-radius: 6px;
  width: 100%;
  margin-bottom: 120px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;
  margin-top: 20px;
  margin-bottom: 60px;
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid #DBDBDB;

  iframe {
    padding: 16px 60px;
  }
`;

export const StyledHeader = styled.div`
  font-family: Quicksand !important;
  height: 56px;
  background-color: #1757e1;
  color: #fff;
  font-family: Quicksand;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  display: flex;
  align-items: center;
  padding: 0px 18px;
`;
